/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { OnboardingLegalEntity } from '@tilled-api-client';
import { SelectorTypes } from 'app/core/data/selector-types';

export function isValidState(region: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || !region) {
      return null;
    }

    let validStates: Map<string, string>;
    if (region === OnboardingLegalEntity.RegionEnum.US) {
      validStates = SelectorTypes.statesMap;
    } else if (region === OnboardingLegalEntity.RegionEnum.CA) {
      validStates = SelectorTypes.provinceMap;
    } else {
      return null;
    }

    return validStates.has(value) ? null : { invalid: true };
  };
}

export function isValidZipCode(region: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    let regex: RegExp;
    if (region === OnboardingLegalEntity.RegionEnum.US) {
      regex = new RegExp('^\\d{5}(-\\d{4})?$');
    } else {
      regex = new RegExp('^.{1,10}$');
    }

    return regex.test(value) ? null : { invalid: true };
  };
}
